import { MDBCardTitle } from "mdb-react-ui-kit";
import Dropdown from "../add-camera-dropdown";
import { useState, useEffect } from "react";
import { getCameraListService } from "../../services/api-service";

const CamSelection = ({
	selectedCamera,
	setSelectedCamera
}) => {
	const [cameraData, setCameraData] = useState([]);
	useEffect(() => {
		getCameraListService()
			.then((response) => {
				setCameraData(response?.data);
			})
			.catch((error) => {
			});
	}, []);

	return (
		<div className="cam-selc-card">
			<div className="col-6 w-100">
				<MDBCardTitle style={{ color: 'black' }}>Camera Selection</MDBCardTitle>
				<Dropdown
					addCamera={false}
					selectedCamera={selectedCamera}
					setSelectedCamera={setSelectedCamera}
					cameraData={cameraData}
				/>
			</div>
		</div>
	);
};

export default CamSelection;
